import {ParcelPosition, parcelPositionDecoder} from './ParcelPosition'
import {Position, positionDecoder} from './Position'
import {Decoder, object, field} from 'json-bouncer'

export interface ParcelPositionWithPosition {
    parcelPosition: ParcelPosition
    position: Position
}

export function parcelPositionWithPositionDecoder(): Decoder<ParcelPositionWithPosition> {
    return object({
        parcelPosition: field('parcelPosition', parcelPositionDecoder()),
        position: field('position', positionDecoder()),
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ParcelPositionWithPosition.ts